var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DB5800",
    d: "M37.5,72.2c-2.4,0-4.7-1.4-5.8-3.5l-5-9.9l-1.9-0.9L11.7,85.7c-0.4,0.8,0.3,1.7,1.2,1.5l13.1-2.5     c0.5-0.1,0.9,0.1,1.1,0.5l6.4,11.6c0.4,0.8,1.5,0.7,1.9-0.1l13.2-28l-9.1,3C38.8,72,38.2,72.2,37.5,72.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DB5800",
    d: "M88.3,85.7L75.2,57.8l-1.9,0.9l-5,9.9c-1.1,2.2-3.3,3.5-5.8,3.5c-0.7,0-1.4-0.1-2-0.3l-9.1-3l13.2,28     c0.4,0.8,1.5,0.8,1.9,0.1l6.4-11.6c0.2-0.4,0.7-0.6,1.1-0.5l13.1,2.5C88,87.4,88.7,86.5,88.3,85.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DB5800",
    d: "M50,19.3c-8.9,0-16.1,7.2-16.1,16.1S41.1,51.6,50,51.6c8.9,0,16.1-7.2,16.1-16.1S58.9,19.3,50,19.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#0B68AD",
    d: "M64.9,66.9l5.2-10.2c0.3-0.5,0.7-0.9,1.2-1.2l10.2-5.2c1.2-0.6,1.7-2,1.3-3.2l-3.5-10.9c-0.2-0.5-0.2-1.1,0-1.7l3.5-10.9     c0.4-1.3-0.2-2.6-1.3-3.2l-10.2-5.2c-0.5-0.3-0.9-0.7-1.2-1.2L64.9,4c-0.6-1.2-2-1.7-3.2-1.3L50.8,6.2c-0.5,0.2-1.1,0.2-1.7,0     L38.3,2.6C37,2.2,35.7,2.8,35.1,4l-5.2,10.2c-0.3,0.5-0.7,0.9-1.2,1.2l-10.2,5.2c-1.2,0.6-1.8,2-1.3,3.2l3.5,10.9     c0.2,0.5,0.2,1.1,0,1.7l-3.5,10.9c-0.4,1.3,0.2,2.6,1.3,3.2l10.2,5.2c0.5,0.3,0.9,0.7,1.2,1.2l5.2,10.2c0.6,1.2,2,1.7,3.2,1.3     l10.9-3.5c0.5-0.2,1.1-0.2,1.7,0l10.9,3.5C63,68.6,64.3,68.1,64.9,66.9z M50,55.4c-11,0-19.9-8.9-19.9-19.9     c0-11,8.9-19.9,19.9-19.9c11,0,19.9,8.9,19.9,19.9C69.9,46.4,61,55.4,50,55.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.a5cf815a.svg";
export { ForwardRef as ReactComponent };